let timelineElements = [
    {
      id: 1,
      title: "MCA",
      location: "National Institute of Technology Kurukshetra",
      cgpa:"8.72",
      date: "present",
      icon: "school",
    },
    {
      id: 2,
      title: "BCA",
      location: "Modern College of Arts, Science and Commerce Pune, Maharashtra",
      cgpa:"8.86",
      date: "2017 - 2020",
      icon: "school",
    },
  ];
  
  export default timelineElements;